import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';

// User card component for the modal
const UserCard = ({ user }) => {
  const navigate = useNavigate();
  
  const goToProfile = () => {
    navigate(`/${user.username}`);
  };
  
  return (
    <div 
      className="d-flex align-items-center p-3 border-bottom hover-overlay"
      onClick={goToProfile}
      style={{ cursor: 'pointer' }}
    >
      {user.photo ? (
        <img
          src={user.photo}
          alt={`${user.first_name} ${user.last_name}`}
          className="rounded-circle"
          style={{ width: '48px', height: '48px', objectFit: 'cover' }}
        />
      ) : (
        <div 
          className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
          style={{ width: '48px', height: '48px' }}
        >
          {user.first_name.charAt(0)}
        </div>
      )}
      
      <div className="ms-3">
        <div className="fw-bold">{user.first_name} {user.last_name}</div>
        <div className="text-muted small">@{user.username}</div>
      </div>
    </div>
  );
};

// Enhanced profile stats component with Bootstrap modal
const EnhancedProfileStats = ({ user, history }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalUsers, setModalUsers] = useState([]);
  
  const showConnectionsModal = (type) => {
    // Extract the right data based on type
    const userData = type === 'followers' ? history.followers : history.following;
    setModalType(type);
    setModalUsers(userData);
    setModalOpen(true);
  };
  
  return (
    <>
      <div className="profile-stats d-flex">
        <div 
          className="followers me-3"
          onClick={() => showConnectionsModal('followers')}
          style={{ cursor: 'pointer' }}
        >
          <span className="fw-bold">{user.followers}</span> Follower{parseInt(user.followers) > 1 ? 's' : ''}
        </div>
        <div 
          className="following"
          onClick={() => showConnectionsModal('following')}
          style={{ cursor: 'pointer' }}
        >
          <span className="fw-bold">{user.following}</span> Following
        </div>
      </div>
      
      <Modal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalType === 'followers' ? 'Followers' : 'Following'}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {modalUsers.length > 0 ? (
            modalUsers.map((user, index) => (
              <UserCard key={index} user={user} />
            ))
          ) : (
            <div className="p-4 text-center text-muted">No users to display</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EnhancedProfileStats;

